import { render, staticRenderFns } from "./reports-payment-table.vue?vue&type=template&id=06cb9395&scoped=true"
import script from "./reports-payment-table.vue?vue&type=script&lang=js"
export * from "./reports-payment-table.vue?vue&type=script&lang=js"
import style0 from "./reports-payment-table.vue?vue&type=style&index=0&id=06cb9395&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb9395",
  null
  
)

export default component.exports